module.exports = __webpack_public_path__ + "static/x-2c43dfff3bebddfb0850bd48d252dbc3.png";